import { createAppAsyncThunk } from "core/src/store/store.types";
import { BaseEtlImportSchema, EtlImport } from "etl/types";

type CreateEtlImportRequest = Partial<EtlImport>;

export const createEtlImport = createAppAsyncThunk<EtlImport, CreateEtlImportRequest>(
	"etlData/createEtlImport",
	async (data, { extra }) => {
		const response = await extra.etlClient.create(BaseEtlImportSchema, data);
		return response.data;
	}
);
